export const IS_USER_SIGN_IN_STORAGE_KEY = 'SignInNotificationBanner_IsLoggedIn';
